import moment from 'moment';
import { useEffect } from 'react';

interface ISessionTimeoutProps {
  onActive: () => void;
  onIdle: () => void;
  idleTime: number | undefined;
}

// This component checks counter for user's idle time
const SessionTimeout: React.FC<ISessionTimeoutProps> = ({ idleTime, onActive, onIdle }) => {
  let timer: any;
  // List of all interaction types
  const events = ['click', 'scroll', 'load', 'keydown', 'mousemove'];

  // Store last interaction time to local storage on user's every interaction from list above
  const eventHandler = () => {
    localStorage.setItem('lastInteractionTime', moment().toString());
    if (timer && idleTime) {
      onActive();
      startTimer(idleTime);
    }
  };

  // If user has idle time than start counter otherwise clear timer
  useEffect(() => {
    if (idleTime && idleTime > 0) {
      addEvents(idleTime);
    }

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, [idleTime]);

  const startTimer = (time: number) => {
    if (timer) {
      clearTimeout(timer);
    }
    // Checking for user's last interaction time to calculate it is less than user's idle time or not
    timer = setTimeout(
      () => {
        const lastInteractionTime = localStorage.getItem('lastInteractionTime');
        const diff = moment.duration(moment().diff(moment(lastInteractionTime)));
        const timeInterval = time * 1000 * 60;
        if (!timeInterval) return;
        if (diff.asMilliseconds() < timeInterval) {
          startTimer(time);
          onActive();
        } else {
          onIdle();
          clearTimeout(timer);
        }
      },
      time * 1000 * 60,
    );
  };

  const addEvents = (time: number) => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer(time);
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  return null;
};

export default SessionTimeout;
